



































import Vue from 'vue';
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';

export default Vue.component('state-control', {
  name: 'StateControl',
  props: {
    // 'show-modal': {
    //   type: Boolean,
    //   default: false
    // },
    'state-name': {
      // type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showDropdown: false,
      loadingSearchResults: false,
      searchInput: '',
      performSearchTimeout: null as any,
      searchResults: [],
      searchCountResults: 0,
      allowForceResultsMaximum: 150,
      allowForceResults: false,
      processing: false
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  created: function () {
  },
  filters: {
    stateAbbrevName (stateAbbrevName: string ) {
      if (stateAbbrevName && stateAbbrevName.length) {
        return '(' + stateAbbrevName + ')';
      }
      return '';
    }
  },
  methods: {
    searchStates (force: boolean = false) {
      let self = this as any;
      let forceResults = force;
      // clearTimeout(this.performSearchTimeout);
      if (this.processing){ return; }
      this.processing = true;
      this.performSearchTimeout = setTimeout(function () {
        let showLoadingSpinnerTimeout = setTimeout(function () {
          self.loadingSearchResults = true;
        // }, 1000);
        }, 0);
        let currentSearchInput = self.searchInput;
        HTTP.get('/api/states/search?stateNameLike=' + self.searchInput + '&forceResults=' + forceResults)
        .then(function (response) {
          self.processing = false;
          // If the response is a count, display the count message
          // If the response is a list, display the list
          // console.log('response.data.data');
          // console.log(response.data.data);

          // If the search results results are empty, display the count
          // If the count is greater than 0 display the count at the option to force retriving the results
          //  as long as the results are less than 150

          let queryCountResults = response.data.data.count;

          self.searchCountResults = queryCountResults;
          self.searchResults = response.data.data.results;
          self.allowForceResults = queryCountResults < self.allowForceResultsMaximum;

          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingSearchResults = false;

          if (self.searchInput !== currentSearchInput) {
            self.searchStates();
          }
        })
        .catch(function () {
          clearTimeout(showLoadingSpinnerTimeout);
          self.loadingSearchResults = false;

          self.processing = false;
          // if there was an error, "notify" the error
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Getting Results',
            text: 'Something went wrong getting search results!',
            // duration: 5000
          });
          // self.close();
        })
      }, 100);
    },
    selectState (state: any) {
      let newStateObject = {
        id: state.id,
        stateId: state.id,
        stateAbbrev: state.stateAbbrevName,
        stateName: state.stateAbbrevName + ' - ' + state.stateFullName,
        stateFull: state.stateFullName
      };

      this.$emit('selected', newStateObject);
      this.showDropdown = false;
    },
    toggleDropdown () {
      if (this.disabled) {
        return;
      }
      this.showDropdown = !this.showDropdown
      if (this.showDropdown) {

        // this.getProviderOwner();
        this.searchInput = (this as any).stateName;
        this.searchStates();

        let self = this as any;
        // This timeout needs to occure because of the "transition" effect on making the dropdown appear visible from "visibility:hidden".
        // The transition is 300 milliseconds, so this timeout set to greater than about 100ms to allow time for the input element to
        // become visibile before focusing.
        setTimeout(function () {
          self.$refs.search.focus();
          self.$refs.search.select();
        }, 300);
      }
    },

  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/StateControl.vue